import { Error404PageConfig } from "./errors/404/Error404PageConfig";

export const pagesConfigs = [Error404PageConfig];
